let language = {
    SELECT_ADDRESS_ADD_ADDRESS_TEXT: "添加地址",
    SELECT_ADDRESS_EDIT_ADDRESS_TEXT: "编辑地址",
    SELECT_ADDRESS_EMPTY_ADDRESS_TIP: "您的通讯录为空。请先添加通讯录！",
    SELECT_ADDRESS_EDIT_BTN: "编辑",
    SELECT_ADDRESS_CANCEL_BTN: "取消",
    SELECT_ADDRESS_OK_BTN: "确认",
    SELECT_ADDRESS_ADD_BTN: "添加",
    SELECT_ADDRESS_SAVE_BTN: "保存",
    
    SELECT_ADDRESS_TEXT: "选择地址",
};

export { language }